// extracted by mini-css-extract-plugin
export default {"robotType":"RobotTypeLabel_robotType__I1HiR","robotTypeInconsistent":"RobotTypeLabel_robotTypeInconsistent__yM7vc"};